import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Snackbar } from '@mui/material';

// Another user signed in from another app: the switch waits for the user, since pending work
// (queued operations, unsynced Firestore writes) belongs to the user signed in here.
export default function SessionChangedAlert({ switchUser }) {
  const { t } = useTranslation();
  const [switching, setSwitching] = useState(false);

  const handleReload = () => {
    setSwitching(true);
    switchUser();
  };

  return (
    <Snackbar open={!!switchUser} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="warning"
        action={(
          <Button color="inherit" size="small" disabled={switching} onClick={handleReload}>
            {t('sso.reload')}
          </Button>
        )}
      >
        {t('sso.session_changed')}
      </Alert>
    </Snackbar>
  );
}
